import axios from 'axios';

const getDefaultState = () => {
    return {
        ExpeditionLogs: [],
        MemoryCards: [],
    }
};

const state = getDefaultState();

const getters = {
    getterExpeditionLogs: state => state.ExpeditionLogs,
    getterMemoryCards: state => state.MemoryCards,
}

const actions = {

    async getExpeditionLogs({ commit, dispatch, state, rootState}) {
        if (!navigator.onLine && state.ExpeditionLogs.length > 0) {
            console.log('Offline: Using cached expedition logs catalog');
            return state.ExpeditionLogs;
        }

        const fetchCatalog = async () => {
            axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

            let data = await dispatch('file/getFileURL', {
                folderName: `expedition_logs`,
                fileName: 'ExpeditionLogsSummary.json',
            }, {root: true});


            if (data) {
                commit('SET_EXPEDITION_LOGS', data);
                return data;
            }
            return state.ExpeditionLogs;
        };

        const hasBearer = !!rootState.auth?.bearer;
        const hasCached = state.ExpeditionLogs.length > 0;

        if (navigator.onLine && hasCached && hasBearer) {
            fetchCatalog().catch((err) => {
                if (!navigator.onLine && state.ExpeditionLogs.length > 0) {
                    console.log('Offline during expedition logs refresh, keeping cache');
                    return;
                }
                console.error('Background refresh expedition logs failed:', err);
            });
            return state.ExpeditionLogs;
        }

        try {
            return await fetchCatalog();
        }
        catch (err) {
            if (!navigator.onLine && state.ExpeditionLogs.length > 0) {
                return state.ExpeditionLogs;
            }
            console.error('getExpeditionLogs failed:', err);
        }
    },

    async getMemoryCards({ commit, dispatch, state, rootState}) {
        if (!navigator.onLine && state.MemoryCards.length > 0) {
            console.log('Offline: Using cached memory cards catalog');
            return state.MemoryCards;
        }

        const fetchCatalog = async () => {
            axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;

            let data = await dispatch('file/getFileURL', {
                folderName: `memory_cards`,
                fileName: 'MemoryCardsSummary.json',
            }, {root: true});

            if (data) {
                commit('SET_MEMORY_CARDS', data);
                return data;
            }
            return state.MemoryCards;
        };

        const hasBearer = !!rootState.auth?.bearer;
        const hasCached = state.MemoryCards.length > 0;

        if (navigator.onLine && hasCached && hasBearer) {
            fetchCatalog().catch((err) => {
                if (!navigator.onLine && state.MemoryCards.length > 0) {
                    console.log('Offline during memory cards refresh, keeping cache');
                    return;
                }
                console.error('Background refresh memory cards failed:', err);
            });
            return state.MemoryCards;
        }

        try {
            return await fetchCatalog();
        }
        catch (err) {
            if (!navigator.onLine && state.MemoryCards.length > 0) {
                return state.MemoryCards;
            }
            console.error('getMemoryCards failed:', err);
        }
    },

    resetState({ commit }) {
        commit('RESET_STATE');
    },
}

const mutations = {

    SET_EXPEDITION_LOGS(state, data) {
        state.ExpeditionLogs = data;
    },

    SET_MEMORY_CARDS(state, data) {
        state.MemoryCards = data;
    },

    RESET_STATE(state) {
        Object.assign(state, getDefaultState())
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
